// src/pages/auth/Login.js
import React from 'react';
import LoginForm from '../../components/forms/LoginForm';

const Login = () => {
  return <LoginForm />;
};

export default Login;